<template>
    <div :class="energyCardLayout">
        <div class="beg-card-body border h-100">
            <div class="infoButton" v-if="infoMessage" @click="openInfoMessage">
                <i class="fa-light fa-circle-info fa-lg"></i>
            </div>
            <div class="compareText" v-if="compareText" v-html="compareText"></div>
            <div class="energyCardIcon">
                <i :class="faIcon" class="fa-2x"></i>
            </div>
            <div class="value">
                {{ roundedValue }} 
            </div>
            <div class="unitStyle">
           <span v-html="combineUnits"></span>
           </div>
            <em><div class="footer" v-html="footerText">
            </div></em>
        </div>
    </div>
</template>

<script setup>
import { modalDialog } from '@/begComponents/ModalDialog';
import { computed, defineProps, ref, watch, onMounted } from 'vue';
/* import {
 chain, round
} from 'mathjs' */
import { useI18n } from 'vue-i18n';

const i18n = useI18n();
const {t} = useI18n();

const energyCardLayout = "energyCard beg-card position-relative"

const endValue = ref(0.0)
const currentValue = ref(0.0)
/* const preUnit = ref("") */

let stepValue = 0;

const props = defineProps({
    faIcon: String,
    unit: {
        Type: String,
        default: ""
    },
    changeValue: Number,
    footerText: {
        Type: String,
        default: ""
    },
    compareText: String,
    autoUnits: {
        Type: String, // metric|million
        default: ""
    },
    infoMessage: {
        Type: String,
        default: ""
    }
})

const metricBorder = {
    giga: 100000000000,
    mega: 100000000,
    kilo: 100000
}

const millonBorder = {
    billion: 1000000000,
    million: 1000000,
    thousand: 1000
}

const weightBorder = {
    tons: 1000000
}

const preUnit = computed(() => {
    const theCurrentValue = Math.abs(currentValue.value)
    if(props.autoUnits == "metric") {
        if(theCurrentValue > metricBorder.giga) {
            return "G"
        }
        if(theCurrentValue > metricBorder.mega) {
                return "M"
            }
        if(theCurrentValue >  metricBorder.kilo) {
                return "k"
            }
    }
    if(props.autoUnits == "million") {
        if(parseInt(theCurrentValue) > parseInt(millonBorder.billion)) {
            //currentValue.value
            return t('billion')
        }
        if(parseInt(theCurrentValue) > parseInt(millonBorder.million)) {
            return t('million')
        }
        if(parseInt(theCurrentValue) > parseInt(millonBorder.thousand)) {
            return t('thousand')
        }
    }
    if(props.autoUnits == "weight") {
        if(parseInt(theCurrentValue) > parseInt(weightBorder.tons)) {
            //currentValue.value
            return t('tons')
        }
        return 'kg'
    }
    return ""
})

const combineUnits = computed(() => {
    if(props.autoUnits === "weight") {
        return preUnit.value
    }
    if(props.autoUnits === "million") {
        return preUnit.value + " " +props.unit
    }
    return preUnit.value + props.unit
})

const roundedValue = computed(() => {
    let calValue =   currentValue.value
    if(props.autoUnits == "metric") {
        if(Math.abs(calValue) > metricBorder.giga) {
            calValue = calValue / 1000000000
        } else if(Math.abs(calValue) > metricBorder.mega) {
            calValue = calValue / 1000000
        } else if(Math.abs(calValue) > metricBorder.kilo) {
            calValue = calValue / 1000
        }
    }

    if(props.autoUnits == "million") {
        if(Math.abs(calValue) > millonBorder.billion) {
            calValue = calValue / 1000000000
        } else if(Math.abs(calValue) > millonBorder.million) {
            calValue = calValue / 1000000
        } else if(Math.abs(calValue) > millonBorder.thousand) {
            calValue = calValue / 1000
        }
    }

    if(props.autoUnits == "weight") {
        if(calValue > weightBorder.tons) {
            calValue = calValue / 1000
        }
    }

    if(calValue < 1000000) {
        return parseFloat((Math.round(calValue*100)/100).toFixed(2)).toLocaleString(i18n.locale.value, {minimumFractionDigits: 2})
    }
    
    return parseInt(Math.round(calValue)).toLocaleString(i18n.locale.value)
})

onMounted(() => {
    goToValue(props.changeValue)
})

function goToValue(newValue) {
    currentValue.value = newValue;
    /* currentValue.value = currentValue.value +stepValue;
    if(stepValue > 0) {
            if((Math.round(endValue.value*100)/100) > (Math.round(currentValue.value*100)/100)) {
            setTimeout(() => {
                goToValue()
            }, 500)
        }
    }
    if(stepValue < 0) {
            if((Math.round(endValue.value*100)/100) < (Math.round(currentValue.value*100)/100)) {
            setTimeout(() => {
                goToValue()
            }, 500)
        }
    } */

}


watch(() => props.changeValue,(changeValue) => {
    endValue.value = changeValue
    let i = changeValue-currentValue.value
    stepValue = i/2;
    stepValue
    goToValue(props.changeValue)
   
})

function openInfoMessage() {
    const dialog = modalDialog().addDialog();
    dialog.message = props.infoMessage
    dialog.cancelCaption = t('okay')
}

</script>

<style lang="scss" scoped>
.energyCardIcon {
    color: #008000;
}

.value {
    padding: 10px;
    padding-bottom: 4px;
    font-weight: 600;
    color: #808080;
    font-size: 1.4em;
}

.unitStyle {
    font-size: 0.9em;
    color: #808080;
    margin-bottom: 3px;
}

.energyCard {
width: 215px;
height: 100%;
box-sizing: border-box;

}

.beg-card-body {
    border-radius: 5px;
}

.footer {
    font-size: 0.8em;
    color: #484848;
}
.compareText {
    position: absolute; 
    top: 2px;
    left: 4px;
    font-size: 0.75em;
    font-weight: 600;
    border: solid 1px;
    border-color: #808080;
    color: #808080;
    padding: 3px;
    border-radius: 40px;

}

.infoButton {
    color: #484848;
    position: absolute;
    top: 5px;
    right: 5px;
}

.infoButton:hover {
    color: rgb(211,0,0);
    cursor: pointer;
}
</style>